import type { StoryObj } from '@storybook/html'
import type { CobaltLink as CobaltLinkProps } from './cobalt-link'

export default {
  title: 'Components/Action/cobalt-link',
  argTypes: {
    label: {
      type: { name: 'string', required: true },
      description: 'This is the text of the link. It is **required**.'
    },
    href: {
      type: { name: 'string' },
      description: 'The destination of the link.'
    },
    linkTitle: {
      type: { name: 'string', required: true },
      description: 'This is the title of the link. It is **required** for accessibility concerns. Please provide at list the name of the destination of the link.'
    },
    variant: {
      control: 'radio',
      options: ['primary', 'secondary'],
      description: 'A string indicating the design variation of the link.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'primary' }
      }
    },
    size: {
      control: 'select',
      options: ['small', 'medium', 'large'],
      description: 'A string indicating the size variation of the link.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'medium' }
      }
    },
    disabled: {
      control: 'boolean',
      description: 'A boolean indicating the disable state of the link. The `aria-disabled` attribute relies on this property.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'false' }
      }
    },
    external: {
      control: 'boolean',
      description: 'A boolean indicating if the link is external or not. If `true` it will open in a new tab.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'false' }
      }
    }
  }
}

const TemplateDefault = (args: CobaltLinkProps) => {
  return `<cobalt-link href="${args.href}" label="${args.label}" link-title="${args.linkTitle}" variant="${args.variant}" size="${args.size}" external="${args.external}" disabled="${args.disabled}"></cobalt-link>`
}

export const Default: StoryObj = TemplateDefault.bind({})

Default.args = {
  href: '#',
  label: 'Link',
  linkTitle: 'Explicit description of the destination of this link',
  variant: 'primary',
  size: 'medium',
  external: false,
  disabled: false
}

const TemplateWithIcon = (args: CobaltLinkProps) => {
  return `<cobalt-link href="${args.href}" label="${args.label}" link-title="${args.linkTitle}" icon-name="${args.iconName}"></cobalt-link>`
}

export const WithIcon: StoryObj = TemplateWithIcon.bind({})

WithIcon.args = {
  href: '#',
  label: 'Link',
  linkTitle: 'Explicit description of the destination of this link',
  iconName: 'chevron_right-outline'
}
